// Shared reader for combo guest rehydration on page load. Reads the same
// `fo_<main_id>_<unit>` key that DrawingSvg.storeInLocalStorage writes, so
// reset and download-finished clearing wipe combo state alongside host state.
export const readStoredFormulaOptions = (drawingMainId, unit) => {
  if (!drawingMainId) { return null; }
  try {
    const raw = localStorage.getItem(`fo_${drawingMainId}_${unit}`);
    if (!raw) { return null; }
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};
